// 共享：CMS 图片上传规范校验工具
// 三个 CMS 内容管理页（homeManage/aboutManage/qualificationManage）共用

export const SPECS = {
  HERO_BG: { maxKB: 500, minW: 750, ratio: [3, 2], hint: '建议 1080×720 PNG/JPG，3:2 横图，≤500KB' },
  QUICKNAV_ICON: { maxKB: 80, minW: 96, ratio: [1, 1], hint: '建议 144×144 PNG（透明背景），1:1 正方，≤80KB' },
  ABOUT_LOGO: { maxKB: 100, minW: 192, ratio: [1, 1], hint: '建议 192×192 PNG（透明背景）或 SVG，1:1 正方，≤100KB' },
  ABOUT_SVC_ICON: { maxKB: 50, minW: 96, ratio: [1, 1], hint: '建议 96×96 PNG（透明背景）或 SVG，1:1 正方，≤50KB' },
  CERT_IMAGE: { maxKB: 1024, minW: 600, hint: '建议 ≥600×450 PNG/JPG，≤1MB' },
}

export function readImageSize(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file)
    const img = new Image()
    img.onload = () => {
      URL.revokeObjectURL(url)
      resolve({ w: img.naturalWidth, h: img.naturalHeight })
    }
    img.onerror = (e) => {
      URL.revokeObjectURL(url)
      reject(e)
    }
    img.src = url
  })
}

// vm: Vue 实例，用 vm.$message 输出提示
// 返回 true 表示通过校验（可继续上传），false 表示阻断
export async function checkSpec(vm, file, spec) {
  if (spec.maxKB && file.size / 1024 > spec.maxKB) {
    vm.$message.error(`图片体积应小于 ${spec.maxKB >= 1024 ? (spec.maxKB / 1024) + 'M' : spec.maxKB + 'KB'}`)
    return false
  }
  if (spec.minW || spec.ratio) {
    try {
      const dim = await readImageSize(file)
      if (spec.minW && dim.w < spec.minW) {
        vm.$message.warning(`图片较小（${dim.w}×${dim.h}），建议宽度 ≥ ${spec.minW}px 以避免模糊`)
      }
      if (spec.ratio) {
        const target = spec.ratio[0] / spec.ratio[1]
        const actual = dim.w / dim.h
        if (Math.abs(actual - target) / target > 0.15) {
          vm.$message.warning(`图片比例 ${dim.w}:${dim.h} 与建议 ${spec.ratio[0]}:${spec.ratio[1]} 偏差较大，可能裁剪不理想`)
        }
      }
    } catch (e) {
      // svg 等格式无法读取尺寸时跳过
    }
  }
  return true
}
